module.exports = __webpack_public_path__ + "static/media/large.b0bdb20f.png";